import { render } from "./vplatformprintsubcom.vue?vue&type=template&id=12975ae9&scoped=true"
import script from "./vplatformprintsubcom.vue?vue&type=script&lang=js"
export * from "./vplatformprintsubcom.vue?vue&type=script&lang=js"

import "./vplatformprintsubcom.vue?vue&type=style&index=0&id=12975ae9&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12975ae9"]])

export default __exports__